import React from 'react'
import { ArrowRight } from '@mui/icons-material';
import { IconButton, ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import clsx from 'clsx'
import { OutlinedPushPin, PushPin } from 'icons'
import { ListItemsSubMenuProps } from './ListItemsSubMenu.props'

const ListItemsSubMenu = ({
  menuItem,
  subMenuItem,
  idIndex,
  classes,
  openDropDown,
  handleSubMenu,
  companySlugParam,
  fundSlugParam,
}: ListItemsSubMenuProps) => {
  const {
    id,
    title,
    slug,
    icon,
    subMenu,
    isPinned,
    isPinnable,
    updatePinStatus,
  } = subMenuItem

  const systemIcon = isPinnable && (
    <Tooltip title={isPinned ? 'Unpin' : 'Pin'}>
      <IconButton
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
          updatePinStatus?.(id, title, !!isPinned)
        }}
        size="small"
        aria-label="pin"
      >
        {isPinned ? (
          <PushPin fontSize="inherit" htmlColor="rgba(255, 255, 255, 0.5)" />
        ) : (
          <OutlinedPushPin
            fontSize="inherit"
            htmlColor="rgba(255, 255, 255, 0.5)"
            className="pin-company"
            opacity="0"
          />
        )}
      </IconButton>
    </Tooltip>
  )

  const actionIcon = systemIcon ?? icon;

  return (
    <div data-testid="submenu">
      <ListItem
        id={`sidebar-menu-item-${idIndex + 1}`}
        className={clsx(
          classes.item,
          classes.subitem,
          'sidebar-menu-second-level',
          {
            [classes.subItemAction]: !!icon,
          }
        )}
        onMouseEnter={(event: React.MouseEvent) =>
          openDropDown(event, menuItem, subMenuItem)
        }
        onClick={(event: React.MouseEvent) => handleSubMenu(event, subMenuItem)}
        aria-describedby="dropdown-anchor"
        aria-controls={slug}
      >
        {actionIcon && (
          <ListItemIcon className={classes.subItemIcon}>
            {actionIcon}
          </ListItemIcon>
        )}
        <ListItemText
          inset={!actionIcon}
          primary={title}
          className={clsx(classes.subitemText, {
            [classes.activeSubMenuItem]:
              companySlugParam === slug || fundSlugParam === slug,
          })}
        />

        {subMenu && subMenu.length > 0 && (
          <ListItemIcon className={classes.rightDropIcon}>
            <ArrowRight />
          </ListItemIcon>
        )}
      </ListItem>
    </div>
  )
}

export default ListItemsSubMenu
